/* eslint-disable react/no-array-index-key */
import React from 'react'
import StarRatings from 'react-star-ratings'
import styled from 'styled-components'
import tw from 'twin.macro'
import VisibilitySensor from 'react-visibility-sensor'
import CountUp from 'react-countup'
import { Block } from '../../../utils'
import AppStore from '../../../images/logos/app-store'
import GooglePlay from '../../../images/logos/google-play'
import { rating as config } from '../../../config'
import { Button, RegisterButton } from '../../UI'
import QRCode from '../../../images/home/tellowQRCode.png'

// Note: has to be at least 18 entries (L+R combined).
const left = [
    'https://images.unsplash.com/photo-1600275669439-14e40452d20b?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fHdvcmtpbmd8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=320&q=60',
    'https://images.unsplash.com/photo-1498758536662-35b82cd15e29?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=320&q=60',
    'https://images.unsplash.com/photo-1485217988980-11786ced9454?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=320&q=60',
    'https://images.unsplash.com/photo-1601058272524-0611e132f3c9?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=320&q=60',
    'https://images.unsplash.com/photo-1590649880765-91b1956b8276?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=320&q=60',
    'https://images.unsplash.com/photo-1552960394-c81add8de6b8?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=320&q=60',
    'https://images.unsplash.com/photo-1612211168136-2eb007670ef9?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=320&q=60',
    'https://images.unsplash.com/photo-1507207908229-c59ddb730e40?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=320&q=60',
    'https://images.unsplash.com/photo-1571826867433-29518cc0b091?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=320&q=60',
    'https://images.unsplash.com/photo-1616499150891-9ff9f39dedde?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=320&q=60',
]
const leftDeepCopy = [...left]

const right = [
    'https://images.unsplash.com/photo-1555421689-3f034debb7a6?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=320&q=60',
    'https://images.unsplash.com/photo-1511250503134-89501c53a815?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=320&q=60',
    'https://images.unsplash.com/photo-1584213447128-7d708614348c?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=320&q=60',
    'https://images.unsplash.com/photo-1592329347431-0943ca753471?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=320&q=60',
    'https://images.unsplash.com/photo-1518186233392-c232efbf2373?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=320&q=60',
    'https://images.unsplash.com/photo-1581464668603-1b215d0c5469?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=320&q=60',
    'https://images.unsplash.com/photo-1610702875413-f4eed90dd2fd?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=320&q=60',
    'https://images.unsplash.com/photo-1613324996029-f6190a17838f?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=320&q=60',
    'https://images.unsplash.com/photo-1530892691885-a2e83d1e6193?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=320&q=60',
    'https://images.unsplash.com/photo-1564564295391-7f24f26f568b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=320&q=60',
]
const rightDeepCopy = [...right]

const data = [
    {
        name: 'Apple',
        link: 'https://app.adjust.com/41l68g0?campaign=Homepage&adgroup=iOS&creative=app_block&fallback=https%3A%2F%2Fapps.apple.com%2Fnl%2Fapp%2Ftellow%2Fid1187872148&redirect_android=https%3A%2F%2Fapps.apple.com%2Fnl%2Fapp%2Ftellow%2Fid1187872148&redirect_ios=https%3A%2F%2Fapps.apple.com%2Fnl%2Fapp%2Ftellow%2Fid1187872148',
        logo: AppStore,
        rating: config.appstore,
    },
    {
        name: 'Android',
        link: 'https://app.adjust.com/b8zrw9z?campaign=Homepage&adgroup=Android&creative=app_block&fallback=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dnl.tellow.app%26hl%3Dnl&redirect_android=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dnl.tellow.app%26hl%3Dnl&redirect_ios=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dnl.tellow.app%26hl%3Dnl',
        logo: GooglePlay,
        rating: config.playstore,
    },
]

const Faces = ({ styling, imgStyleOverwrite, direction, hideOnMobile }) => (
    <div style={{ width: '250%', transform: direction === 'left' ? 'translateX(-50%)' : '' }} css={[hideOnMobile && tw`hidden! sm:grid!`, tw`grid grid-cols-3 gap-2.5`, styling]}>
        {[
            [0, 1, 2],
            [3, 4, 5],
            [6, 7, 8],
        ].map((a, rowIndex) =>
            a.map((idx, columnIndex) => (
                <img
                    key={`fl${rowIndex}${columnIndex}`}
                    src={direction === 'left' ? leftDeepCopy[idx] : rightDeepCopy[idx]}
                    css={[
                        imgStyleOverwrite,
                        // Middle images do not need a shadow;
                        // this makes the shadow look less 'muddy' (only for desktop).
                        // (columnIndex === 2 || columnIndex === 0) && hideOnMobile && tw`shadow-purple`,
                        // Offset the middle row based on direction.
                        rowIndex === 1 && (direction === 'right' ? tw`ml-4` : tw`-ml-4`),
                        // Default styling.
                        tw`mb-0 max-h-32 h-44 w-full object-cover object-center bg-white rounded-lg`,
                    ]}
                    alt="Freelancer"
                />
            ))
        )}
    </div>
)

const contentStyle = {
    span: tw`col-span-2`,
    announcer: tw`antialiased sm:text-center uppercase tracking-wide font-normal text-tellow-purple mb-0`,
    title: tw`sm:text-center text-gray-800 font-black tracking-tight antialiased mb-8 mt-4 sm:mb-12 sm:text-2xl md:text-3xl lg:text-4xl`,
    item: tw`flex flex-col lg:hidden lg:flex-row my-4 bg-white shadow-xl rounded-2xl p-4 text-gray-800 transition-shadow duration-500 ease-in-out hover:shadow-purple`,
    bottom: tw`flex flex-1 items-center justify-center bg-gray-50 rounded-lg py-4`,
    logo: tw`flex cursor-pointer flex-1 justify-center w-full sm:max-w-xs my-4 max-h-8 mx-2`,
}

const time = 150
const qrSize = 9
const textHeight = 2

const QrCodeContainerText = styled.p`
    transition: ${time / 2}ms ease-in-out;
    height: ${textHeight}rem;
    width: 100%;

    display: grid;
    place-content: center;

    font-weight: ${({ theme }) => theme.font.weight.regular};
    font-size: ${({ theme }) => theme.font.size.xxxs};
    text-align: center;
    line-height: 1.35;

    opacity: 0;
    margin: 0;
`

const QrCodeContainer = styled.div`
    transform: translateX(50%);
    transition: ${time}ms ease-in-out;
    border-radius: 1rem;

    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    width: ${qrSize}rem;
    height: ${qrSize}rem;
    padding: 1rem;

    background-color: ${({ theme }) => theme.color.tellowWhite};
    will-change: transform, z-index, box-shadow;
    transition: ${time}ms ease-in-out;

    position: absolute;
    overflow: hidden;
    right: 50%;

    &:hover {
        z-index: 10;
        height: ${qrSize + textHeight}rem;
        transform: translateX(50%) scale(1.8);
        box-shadow: ${({ theme }) => theme.smoothShadow}, 0 0 120px 0 rgba(0, 0, 0, 0.2);

        ${QrCodeContainerText} {
            opacity: 1;
        }
    }

    @media (max-width: 1023px) {
        display: none;
    }
`

const DesktopQrComponent = styled.div`
    display: flex;
    align-items: center;
    min-height: ${qrSize}rem;
    min-width: ${qrSize}rem;
    position: relative;

    @media (max-width: 1023px) {
        display: none;
    }
`

const QrCodeContainerImg = styled.img`
    width: 100%;
    margin: 0;
`

const DownloadArrowPointer = styled.div`
    display: flex;
    position: relative;

    transform: rotate(-10deg);
    height: min-content;
    max-width: 150px;

    line-height: 1;
    font-size: 1.2rem;
    text-align: center;
    font-family: 'Nanum Pen Script';

    color ${({ theme }) => theme.color.tellowPurple};

    &:after {
        content: '';
        position: absolute;

        height: 1.5rem;
        bottom: -50%;
        width: 4rem;
        right: -25%;

        background: url("data:image/svg+xml,%3Csvg width='146' height='49' viewBox='0 0 146 49' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M144.672 28.9318C145.659 29.4264 146.059 30.6279 145.564 31.6156L137.505 47.7107C137.011 48.6983 135.809 49.0981 134.822 48.6036C133.834 48.109 133.434 46.9074 133.929 45.9198L141.092 31.613L126.786 24.4494C125.798 23.9549 125.398 22.7533 125.893 21.7656C126.387 20.7779 127.589 20.3782 128.577 20.8727L144.672 28.9318ZM13.9354 8.48066C14.8787 9.05537 15.1775 10.2859 14.6027 11.2292C14.028 12.1725 12.7975 12.4713 11.8542 11.8966L13.9354 8.48066ZM20.1314 16.637C19.1589 16.1132 18.7952 14.9002 19.319 13.9277C19.8428 12.9552 21.0558 12.5915 22.0282 13.1153L20.1314 16.637ZM47.5171 24.5453C48.5549 24.9237 49.0893 26.0718 48.7108 27.1095C48.3323 28.1472 47.1843 28.6816 46.1466 28.3031L47.5171 24.5453ZM55.1651 31.3439C54.11 31.0171 53.5196 29.8968 53.8464 28.8417C54.1733 27.7866 55.2935 27.1962 56.3487 27.523L55.1651 31.3439ZM83.5693 33.6394C84.6635 33.7904 85.4281 34.7998 85.2771 35.894C85.1262 36.9882 84.1167 37.7529 83.0225 37.6019L83.5693 33.6394ZM92.5044 38.6194C91.403 38.5354 90.5782 37.5746 90.6622 36.4732C90.7461 35.3718 91.707 34.547 92.8084 34.631L92.5044 38.6194ZM120.595 33.9662C121.69 33.8236 122.694 34.5959 122.836 35.6913C122.979 36.7866 122.207 37.7901 121.111 37.9327L120.595 33.9662ZM130.54 36.3454C129.459 36.5697 128.4 35.8749 128.176 34.7933C127.951 33.7118 128.646 32.6531 129.728 32.4287L130.54 36.3454ZM2.43898 0.691286C5.57518 3.09016 9.44178 5.74288 13.9354 8.48066L11.8542 11.8966C7.25477 9.09435 3.26987 6.36282 0.00879259 3.86842L2.43898 0.691286ZM22.0282 13.1153C29.4696 17.1235 38.0727 21.1007 47.5171 24.5453L46.1466 28.3031C36.5086 24.788 27.7301 20.7299 20.1314 16.637L22.0282 13.1153ZM56.3487 27.523C64.9412 30.1846 74.0835 32.3305 83.5693 33.6394L83.0225 37.6019C73.2969 36.2598 63.9412 34.0624 55.1651 31.3439L56.3487 27.523ZM92.8084 34.631C101.887 35.323 111.205 35.1887 120.595 33.9662L121.111 37.9327C111.423 39.1941 101.828 39.3301 92.5044 38.6194L92.8084 34.631ZM129.728 32.4287C134.201 31.5007 138.679 30.3081 143.145 28.8224L144.408 32.6179C139.79 34.1541 135.161 35.3867 130.54 36.3454L129.728 32.4287Z' fill='%235950EC'/%3E%3C/svg%3E%0A")
            center center / contain no-repeat;
    }
`
// The visibility sensor starts the counter when the component is visible

const Content = ({ content }) => (
    <div css={contentStyle.span}>
        <p css={contentStyle.announcer}>{content.primary.announcer.text}</p>
        <h2 css={contentStyle.title}>
            {content.primary.app_title.text}
            <wbr />
            <CountUp start={130500} duration={1.5} end={150000} separator=".">
                {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                        <span style={{ minWidth: '6ch', display: 'inline-block' }} ref={countUpRef} />
                    </VisibilitySensor>
                )}
            </CountUp>

            {content.primary.app_title_after_freelancer_number.text}
        </h2>

        {data.map(({ logo: Logo, name, link, rating }) => (
            <div key={name} css={contentStyle.item}>
                <a css={contentStyle.logo} href={link} aria-label={name} target="_blank" rel="noopener noreferrer">
                    <Logo fill="black" />
                </a>
                <div css={contentStyle.bottom}>
                    <StarRatings starDimension="28px" starSpacing="2px" starRatedColor="rgba(0,0,0,0.8)" starEmptyColor="rgba(0,0,0,.15)" rating={rating} />
                </div>
            </div>
        ))}

        <DesktopQrComponent>
            <QrCodeContainer>
                <QrCodeContainerImg src={QRCode} alt="App Store QR Code" />
                <QrCodeContainerText>Scan de code om de Tellow app te downloaden</QrCodeContainerText>
            </QrCodeContainer>
            <DownloadArrowPointer>Download de app gratis</DownloadArrowPointer>
        </DesktopQrComponent>
    </div>
)

const Speech = () => (
    <svg xmlns="http://www.w3.org/2000/svg" css={tw`hidden sm:inline-block h-4 w-4 mr-4`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            fill="none"
            d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
        />
    </svg>
)

const actionStyle = {
    solid: tw`flex justify-center items-center whitespace-pre-wrap break-normal`,
    outlined: tw`bg-white! border-2 border-solid border-tellow-purple! text-tellow-purple whitespace-pre-wrap break-normal flex items-center justify-center text-center`,
}
const Actionables = ({ content }) => (
    <>
        <RegisterButton big purple css={actionStyle.solid} href="/reviews">
            {content.primary.primary_button.text} &nbsp; <span className="arrow">{'->'}</span>
        </RegisterButton>
        <Button big css={actionStyle.outlined} href="/reviews">
            <Speech />
            {content.primary.review_buton.text}
        </Button>
    </>
)

const blockStyle = {
    block: tw`relative overflow-hidden`,
    container: tw`max-w-7xl pt-0 md:pt-15 pb-5 mx-auto px-4 sm:px-6 lg:px-8`,
    wrap: tw`relative z-10 w-full pb-8 sm:pb-10 md:pb-14 lg:pb-20 xl:pb-24`,
    mobile: tw`flex sm:hidden`,
    desktop: tw`grid grid-cols-1 sm:grid-cols-4 gap-20 mx-auto items-start sm:items-center`,
    wide: tw`mb-8 -ml-10 -mr-10`,
    left: tw`-ml-14`,
    right: tw`-mr-14`,
    actions: tw`mx-auto max-w-xs space-y-4 pt-10`,
}
const AppsBlock = ({ content }) => (
    <Block color="tellowGray800" bold css={blockStyle.block}>
        <div css={blockStyle.container}>
            <div css={blockStyle.wrap}>
                {/* Mobile */}
                <div css={blockStyle.mobile}>
                    <Faces styling={blockStyle.wide} imgStyleOverwrite={tw`h-24!`} />
                </div>

                {/* Desktop */}
                <div css={blockStyle.desktop}>
                    <Faces hideOnMobile styling={blockStyle.left} direction="left" />
                    <Content content={content} />
                    <Faces hideOnMobile styling={blockStyle.right} direction="right" />
                </div>
                <div css={blockStyle.actions}>
                    <Actionables content={content} />
                </div>
            </div>
        </div>
    </Block>
)

export default AppsBlock
